export default {
  title: '账号登录',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  password: '密码',
  passwordPlaceholder: '请输入密码',
  rememberMe: '记住我',
  forgotPassword: '忘记密码?',
  loginButton: '立即登录',
  agreement: '我已阅读并同意',
  serviceAgreement: '服务协议',
  privacyAgreement: '隐私协议',
  and: '和',
  emailRequired: '请输入邮箱',
  passwordRequired: '请输入密码',
  emailInvalid: '请输入有效的邮箱地址',
  passwordInvalid: '密码至少8位，需包含字母和数字',
  agreementRequired: '请同意服务协议和隐私协议',
  loginSuccess: '登录成功',
  loginFailed: '登录失败',
};
